import React from "react";
import styles from "./styles.module.css";
import { Link } from "react-router-dom";
// import image from "../../assets/logo.png";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
const Footer = () => {
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        <div className={styles.card}>
          {/* <img src={image} alt="logo" /> */}
        </div>
        <div className={styles.card}>
          <br />
          <br />
          <ul></ul>
        </div>
        <div className={styles.card}>
          <br />
          <br />
          <ul></ul>
        </div>
        <div className={styles.card}></div>
      </div>
      <div className={styles.rights}>
        <div>
          <Link to="/login">
            &copy; 2023 Lotus Beta Analytics All Rights & Reserved
          </Link>
        </div>
        <div>
          <a href="https://web.facebook.com/lotusbetaanalytics">
            <FaFacebook />
          </a>
          <a href="https://twitter.com/lotusbeta">
            <FaTwitter />
          </a>
          <a href="https://www.instagram.com/lbannigeria">
            <FaInstagram />
          </a>
          <a href="https://www.linkedin.com/company/lotus-beta-analytics">
            <FaLinkedinIn />
          </a>
          <a href="https://www.youtube.com/channel/UCOhLIAisZyiolylqVhuq2qg">
            <FaYoutube />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
